module.exports = __webpack_public_path__ + "img/chart-pyramid.eedfa538.svg";